import React from "react";
import { useState, useEffect, PropsWithChildren } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { getUserProfileAsync, getUserPhotoAsync } from "../../infrastructure/auth/authConfig";
import { userProfile } from "./UserContext.d";
import { UserContext } from "./UserContext";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";

const UserProvider: React.FC<PropsWithChildren<any>> = (props) => {
	const { instance, accounts } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const [profile, setProfile] = useState<userProfile | undefined>(undefined);

	useEffect(() => {
		async function getUserDetailsAsync() {
			if (isAuthenticated) {
				if (accounts[0]) {
					const response = await instance.acquireTokenSilent({
						scopes: ["User.Read"],
						account: accounts[0],
					});
					setProfile({
						...(await getUserProfileAsync(response.accessToken)),
						photo: await getUserPhotoAsync(response.accessToken),
					});
				}
			}
		}
		getUserDetailsAsync();
	}, [isAuthenticated, accounts, instance]);

	return (
		<>
			<LoadingIndicator content="Loading profile" open={profile === undefined} />
			{profile && <UserContext.Provider value={profile}>{props.children}</UserContext.Provider>}
		</>
	);
};
export default UserProvider;
